var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _c("div", { staticClass: "form-group" }, [
      _vm.getSystemSetting("resource__file_upload")
        ? _c(
            "div",
            { staticClass: "upload-field-box__content" },
            [
              _c("VueFilePond", {
                ref: "resourcePond",
                attrs: {
                  name: "file",
                  "label-idle": "Drop files here or Click to select files",
                  fileValidateTypeLabelExpectedTypes:
                    "Expects pdf,images,videos,zip,document formats.",
                  "accepted-file-types": [
                    "image/*",
                    "video/*",
                    "application/pdf",
                    "application/zip",
                    "application/x-zip",
                    "application/x-zip-compressed",
                    "text/plain",
                    "text/csv",
                    "application/vnd.oasis.opendocument.text",
                    "application/msword",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "application/vnd.oasis.opendocument.spreadsheet",
                    "application/vnd.ms-powerpoint",
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                    "application/vnd.oasis.opendocument.presentation"
                  ],
                  "max-file-size": "25MB",
                  "allow-multiple": true,
                  allowRemove: true,
                  allowRevert: false,
                  allowReorder: true,
                  allowProcess: false,
                  instantUpload: false,
                  dropOnElement: true,
                  dropOnPage: true,
                  dropValidation: true,
                  files: _vm.filepond,
                  checkValidity: true
                }
              })
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: { click: _vm.saveFn }
          },
          [_vm._v("Upload")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }